import { TayehModule } from '../type'
import routes from './router'

export const LandingModule : TayehModule = {
    name: 'Landing',
    base_route: '',
    routes,

}